import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import useMediaQuery from '@mui/material/useMediaQuery';
import Modal from '@mui/material/Modal';

import makeStyles from './style';
import Card from '../../assets/images/card.png';
import CardBack from '../../assets/images/card back.png';
import QuestionMark from '../../assets/images/qMark.svg';
import {
  triggerCVVModal,
  triggerExpiryDateModal,
} from '../../redux/actions/appState';

const InformativeModal = (props) => {
  const { language, cvvModalFlag, expiryDateModalFlag } = useSelector(
    (state) => ({
      language: state?.appState?.language,
      cvvModalFlag: state?.appState?.cvvModalFlag,
      expiryDateModalFlag: state?.appState?.expiryDateModalFlag,
    }),
  );
  const classes = makeStyles({ language });
  const isMobileView = useMediaQuery('(max-width:600px)');
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { type } = props;
  const modalOpen = type === 'cvv' ? cvvModalFlag : expiryDateModalFlag;
  const setModal = type === 'cvv' ? triggerCVVModal : triggerExpiryDateModal;

  return (
    <>
      <button
        aria-haspopup={isMobileView}
        type="button"
        className={classes.openButton}
        style={{ backgroundColor: 'transparent' }}
        onClick={() => {
          isMobileView ? dispatch(setModal(true)) : null;
        }}
      >
        <img src={QuestionMark} className={`${classes.questionMarkLogo} `} />
      </button>

      {isMobileView && (
        <Modal
          open={modalOpen}
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'flex-end',
            zIndex: 1,
            backdropFilter: 'blur(10px)',
          }}
          onBackdropClick={() => dispatch(setModal(false))}
        >
          <div className={classes.modalContentContainer}>
            <div className={classes.textAndImgContainer}>
              <div>
                <h2 className={classes.modalTitle}>{t(`${type}`)}</h2>
                <h5 className={classes.modalText}>{t(`${type}HelperText`)}</h5>
              </div>
              <img
                src={type === 'cvv' ? CardBack : Card}
                className={classes.img}
              />
            </div>
            <button
              className={classes.button}
              onClick={() => dispatch(setModal(false))}
            >
              <h6 className={classes.buttonText}>
                {t('informativeModalButtonText')}
              </h6>
            </button>
          </div>
        </Modal>
      )}
    </>
  );
};

export default InformativeModal;
